<ngx-spinner bdColor="rgba(51,51,51,0.8)" size="medium" color="#f7ac0a" type="ball-atom">
    <p style="font-size: 20px; color: #0072bc">Loading...</p>
</ngx-spinner>

<main id="wrapper">
    <header>
        <div class="container-fluid">
            <div class="navWrap">
                <div class="linksWrap">
                    <div class="logo">
                        <a href="index.html"><img src="./assets/images/logo.png" alt="Bajaj Life"
                                title="Bajaj Life" /></a>
                    </div>
                </div>
            </div>
        </div>
    </header>
    <section class="position-relative emandate">
        <div class="leftSide">
            <!--Steps for Mobile View-->
            <div class="progress-container disp-mobile">
                <div class="progress" id="progress"></div>
                <div class="text-wrap">
                    <div class="content">
                        <p class="heading">Register online mandate</p>
                        <p class="text">Set the mode of transaction for online mandate registration</p>
                    </div>
                    <div class="stepCount disabled">3</div>
                </div>
            </div>
            <!--Mobile View steps End-->
        </div>
        <div class="rightSide">
            <h2>AUTOPAY MANDATE REGISTRATION</h2>
            <!--Register Online Mandate-->
            <div class="accordion-item">
                <h2 class="accordion-header">
                    <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                        data-bs-target="#collapseThree" aria-expanded="false" aria-controls="collapseThree">
                        <img src="./assets/images/003-portal.png" class="img-fluid">&nbsp;&nbsp; Register Online
                        Mandate
                    </button>
                    <!--Desktop step-3-->
                    <div class="stepCountRow disp-desktop">
                        <div class="content">
                            <p class="heading">Register online mandate</p>
                            <p class="text">Set the mode of transaction for online mandate registration</p>
                        </div>
                        <p class="stepCount disabled">3</p>
                    </div>
                </h2>
                <!-- End-->
                <div id="collapseThree" class="accordion-collapse collapse" #collapseThree>
                    <div class="accordion-body" *ngIf="showAccodian3 ">
                        <div class="button-group mb-4">
                            <div class="paymentOption" *ngIf="showCCSIPan">
                                <input class="form-check-input" type="radio" name="paymentOption" id="creditCard"
                                    [(ngModel)]="selectedPaymentOption" value="domesticcreditCard" ngIf="showCCSI">
                                <label class="form-check-label" for="creditCard">
                                    CCSI via Domestic Card
                                </label>
                            </div>
                            <div class="paymentOption" *ngIf="showCCSINRI">
                                <input class="form-check-input" type="radio" name="paymentOption"
                                    id="internationalcreditCard" [(ngModel)]="selectedPaymentOption"
                                    value="internationalcreditCard">
                                <label class="form-check-label" for="internationalcreditCard">
                                    CCSI via International Card
                                </label>
                            </div>
                        </div>

                        <div class="button-group UPI position-relative my-5 " id="DomesticCardDetails"
                            *ngIf="selectedPaymentOption === 'domesticcreditCard'">
                            <a href="#"><img src="./assets/images/visa.png" class="img-fluid"></a>
                            <a href="#"><img src="./assets/images/mastercard.png" class="img-fluid"></a>
                            <a href="#"><img src="./assets/images/dinerClub.png" class="img-fluid"></a>
                        </div>
                        <div class="button-group UPI position-relative my-5 " id="InternationalCardDetails"
                            *ngIf="selectedPaymentOption === 'internationalcreditCard'">
                            <a href="#"><img src="./assets/images/visa.png" class="img-fluid"></a>
                            <a href="#"><img src="./assets/images/mastercard.png" class="img-fluid"></a>
                        </div>

                        <p class="disclaimer mt-5">Note: Please keep your Net Banking credential and registered
                            mobile number handy as you will be redirected to Bank page for further
                            authorization. Click “Submit” to register once you are ready.
                        </p>
                        <div class="form-check disclaimer">
                            <input class="form-check-input" type="checkbox" value="" id="flexCheckDefault"
                                [(ngModel)]="isChecked">
                            <label class="form-check-label" for="flexCheckDefault">
                                I declare that the mandate is being registered by me through a bank account in
                                my name or a Credit/Debit Card or through a Prepaid Payment Instrument (Wallet),
                                held by me in my name as a primary holder and is not a third party account by
                                any other person on my behalf.
                            </label>
                        </div>
                        <div class="formGroup my-5">
                            <button type="submit" class="btn btn-orange" (click)="onProceed()"
                                [disabled]="!isChecked">Submit</button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </section>


<div hidden>
    <form ngNoForm action={{emandate}} id="existCustEmandate" name="existCustEmandatefrm" target="_self"
    method="post">
    <input type="hidden" id="moduleName1" name="moduleName" value="OPEN_LINK_NEW">
    <input type="hidden" id="policyHolderNameexeman" name="policyHolderName" value="">
    <input type="hidden" id="totalAmountexeman" name="totalAmount" value="">
    <input type="hidden" id="consumerIdexeman" name="consumerId" value="">
    <input type="hidden" id="consumerMobileNoexeman" name="consumerMobileNo" value="">
    <input type="hidden" id="consumerEmailIdexeman" name="consumerEmailId" value="">
    <input type="hidden" id="debitStartDateexeman" name="debitStartDate" value="">
    <input type="hidden" id="debitEndDateexeman" name="debitEndDate" value="">
    <input type="hidden" id="maxAmountexeman" name="maxAmount" value="">
    <input type="hidden" id="amountTypeexeman" name="amountType" value="">
    <input type="hidden" id="frequencyexeman" name="frequency" value="">
    <input type="hidden" id="moduleIdexeman" name="moduleName" value="">
    <input type="hidden" id="renewalIDexeman" name="renewalID" value="">
    <input type="hidden" id="payableAmountexeman" name="payableAmount" value="">
    <input type="hidden" id="accountNo" name="takeAccountNo" value="">
    <input type="hidden" id="ifscCode" name="takeIFSCCode" value="">
    <button type="submit" class="btn btn-success" #myDiv class="clickhere">click here</button>
    </form>


    <form ngNoForm action={{enach}} id="existCustEmandate" name="existCustEmandatefrm" target="_self"
    method="post">
    <input type="hidden" id="moduleNameenach" name="moduleName" value="INSTAB|OPEN_LINK_NEW">
    <input type="hidden" id="policyHolderNameenach" name="policyHolderName" value="">
    <input type="hidden" id="totalAmountenach" name="totalAmount" value="">
    <input type="hidden" id="consumerIdenach" name="consumerId" value="">
    <input type="hidden" id="consumerMobileNoenach" name="consumerMobileNo" value="">
    <input type="hidden" id="consumerEmailIdenach" name="consumerEmailId" value="">
    <input type="hidden" id="debitStartDateenach" name="debitStartDate" value="">
    <input type="hidden" id="debitEndDateenach" name="debitEndDate" value="">
    <input type="hidden" id="maxAmountenach" name="maxAmount" value="">
    <input type="hidden" id="amountTypeenach" name="amountType" value="">
    <input type="hidden" id="frequencyenach" name="frequency" value="">
    <input type="hidden" id="accountNoe" name="takeAccountNo" value="">
    <input type="hidden" id="ifscCodee" name="takeIFSCCode" value="">
    <button type="submit" class="btn btn-success" #enachform class="clickhere">click here</button>
    </form>
    
    <form ngNoForm action={{upiUrl}} id="newCustUpiMan" name="newCustUpiForm" target="_self" method="post">
      <input type="hidden" id="moduleNameu" name="moduleName" value="OPEN_LINK_NEW">
      <input type="hidden" id="policyHolderNameu" name="policyHolderName" value="">
      <input type="hidden" id="totalAmountu" name="totalAmount" value="">
      <input type="hidden" id="consumerIdu" name="consumerId" value="">
      <input type="hidden" id="consumerMobileNou" name="consumerMobileNo" value="">
      <input type="hidden" id="consumerEmailIdu" name="consumerEmailId" value="">
      <input type="hidden" id="debitStartDateu" name="debitStartDate" value="">
      <input type="hidden" id="debitEndDateu" name="debitEndDate" value="">
      <input type="hidden" id="maxAmountu" name="maxAmount" value="">
      <input type="hidden" id="amountTypeu" name="amountType" value="">
      <input type="hidden" id="frequencyu" name="frequency" value="">
      <input type="hidden" id="renewalIDu" name="moduleName" value="">
      <input type="hidden" id="payableAmountu" name="payableAmount" value="">
      <input type="hidden" id="accountNo" name="takeAccountNo" value="">
      <input type="hidden" id="ifscCode" name="takeIFSCCode" value="">
      <button type="submit" class="btn btn-success" #upiform class="clickhere">click here</button>
    </form>
    
    <form ngNoForm action={{ccsi}} id="CCSIFrm" name="CCSIFrm" target="_self" method="post">
      <input type="hidden" id="moduleNameccsiexi" name="moduleName" value="OPEN_LINK_EXISTING">
      <input type="hidden" id="policyHolderccsiexi" name="policyHolderName" value="">
      <input type="hidden" id="totalAmountccsiexi" name="totalAmount" nvalue="">
      <input type="hidden" id="consumerMobileNoccsiexi" name="consumerMobileNo" value="">
      <input type="hidden" id="consumerEmailIdccsiexi" name="consumerEmailId" value="">
      <input type="hidden" id="debitStartDateccsiexi" name="debitStartDate" value="">
      <input type="hidden" id="debitEndDateccsiexi" name="debitEndDate" value="">
      <input type="hidden" id="return_urlccsiexi" name="return_url" value="">
      <input type="hidden" id="consumerIdccsiexi" name="consumerId" value="">
      <button type="submit" class="btn btn-success" #ccsiform>click
        here</button>
    </form>

</div>